import {
  Box,
  Card,
  CardContent,
  Chip,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
  makeStyles,
} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  chipRoot: {
    borderRadius: "8px",
  },
}));

export function PopularMajors(props) {
  const classes = useStyles();
  const popularMajorItems = [
    { title: "Business Administration And Management General", value: 1587 },
    { title: "Business Administration And Management General", value: 1587 },
  ];
  return (
    <>
      <Card>
        <CardContent className="pb-0">
          <Typography variant="h6">Popular Majors (Degree Programs)</Typography>
        </CardContent>
        <Box>
          <List>
            {popularMajorItems.map((item, index) => (
              <ListItem key={index}>
                <ListItemText style={{ maxWidth: "50%" }}>
                  {item.title}
                </ListItemText>
                <ListItemSecondaryAction>
                  <Chip
                    classes={{ root: classes.chipRoot }}
                    color="primary"
                    size="small"
                    style={{ backgroundColor: "#e2eeff", color: "#488ee6" }}
                    label={item.value + " graduates"}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Box>
      </Card>
    </>
  );
}
